/* eslint consistent-return: 0 */
import Api from 'client/api/v2/Api';
import axios from 'axios';

class SettingsApi extends Api {
  /**
   * @description Replaces the old settings backbone model
   * 'client/backbone/models/Settings.js'
   */
  constructor() {
    super();
    this.baseUrl = '/api/settings';
  }

  /**
   * @description This method is necessary because I need the entire error
   * to be passed back in case this is an MSP - the '/api/settings'
   * endpoint will return a 401 with a 'no org selected' message in the case
   * of an MSP.
   *
   * @todo Remove dependency on old endpoint and move to using
   * '/api/organizations' when it has been updated.
   */
  getGlobalSettings() {
    return super.initialize()
      .then(() => axios.get(this.baseUrl))
      .then(resp => Promise.resolve((resp && resp.data) || ''))
      // Pass back the error message in case this is an MSP admin.
      .catch(error => Promise.reject(error));
  }
}

export default new SettingsApi();
